import { enableApp } from "./be-app-neat";
export { enableApp };
